<template>
  <div class="vx-col w-full">
    <vx-card title="Search Footfall">
      <div v-if="$apollo.loading">
        <div :class="{'activeLoading':activeLoading}" id="loading-default"
             class="vs-con-loading__container loading-example"></div>
      </div>
      <template slot="actions">
        <div class="demo-alignment">
          <datepicker :format="customFormatter(fromDate)" placeholder="Select from date" v-model="fromDate"></datepicker>
          <datepicker :format="customFormatter(toDate)" placeholder="Select to date" v-model="toDate"></datepicker>
          <vs-button color="rgb(0 121 193)" icon-pack="feather" icon="icon-search" >Search</vs-button>
          <vs-button color="rgb(62, 201, 214)" icon-pack="feather" icon="icon-x" @click="clearSearch">Clear Search</vs-button>
        </div>

      </template>
      <!--<vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
          <div class="demo-alignment">
            <datepicker :format="customFormatter(fromDate)" placeholder="Select from date" v-model="fromDate"></datepicker>
            <datepicker :format="customFormatter(toDate)" placeholder="Select to date" v-model="toDate"></datepicker>
            <vs-button color="primary" icon-pack="feather" icon="icon-search" >Search</vs-button>
            <vs-button color="rgb(62, 201, 214)" icon-pack="feather" icon="icon-x" @click="clearSearch">Clear Search</vs-button>
          </div>
        </vs-col>
      </vs-row>-->


      <div class="vx-row">
        <div class="vx-col w-full ">
          <div id="data-list-list-view" class="data-list-container">
            <vs-table
              :sst="true"
              @search="handleSearch"
              @change-page="handleChangePage"
              @sort="handleSort"
              v-model="selected"
              :total="totalItems"
              pagination
              max-items="10"
              :data="footFallList">
              <!--<template slot="header">
                <h3>
                  Footfall List
                </h3>
              </template>-->
              <template slot="thead">
                <vs-th sort-key="email">
                  Name
                </vs-th>
                <vs-th sort-key="username">
                  Gender
                </vs-th>
                <vs-th sort-key="website">
                  Email
                </vs-th>
                <vs-th sort-key="id">
                  Action
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name">
                    {{data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].gender">
                    {{data[indextr].gender}}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{data[indextr].email}}
                  </vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="EditIcon" @click="updateFootFall(data[indextr].id)"
                                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                  class="clickable"/>
                    <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                  class="ml-2 clickable"/>-->
                    <feather-icon icon="EyeIcon" @click="footFallDetal(data[indextr].id)"
                                  svgClasses="w-5 h-5 hover:text-success stroke-current"
                                  class="ml-2 clickable"/>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <br>
            <br>
            <br>
            <br>
            <!--<pre ref="pre"></pre>-->
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        footFallList: [],
        totalItems: 0,
        selected: [],
        fromDate:'',
        toDate:'',
        activeLoading: false
      }
    },
    apollo: {
      me: {
        query: gql`
        query me($reminder_date: DateRange, $first: Int!, $page: Int){
            me{
            id
            manager_name
            phone
            email
            address
            api_token
               footfalls(reminder_date: $reminder_date, first: $first, page: $page){
                paginatorInfo{
                  count
                  currentPage
                  firstItem
                  hasMorePages
                  lastItem
                  lastPage
                  perPage
                  total
                }
                data{
                  id
                  name
                  gender
                  email
                  mobile
                  sources
                  suffix
                  reason
                  product
                  brand
                  reminder_date
                  created_at
                  updated_at
                }
              }

           }
         }
        `,
        variables () {
          this.fromDate = moment(this.fromDate).format("yyyy-MM-DD");
          this.toDate = moment(this.toDate).format("yyyy-MM-DD");
          console.log("Date",this.fromDate );
          return {
            reminder_date:{
              from: this.fromDate === 'Invalid date'? "" : this.fromDate,
              to: this.toDate === 'Invalid date' ? "": this.toDate
            },
            first: 10,
            page: this.selectedPgae
          }
        },
        update: (data) => data.me
      }
    },
    watch: {
      me (value) {
        this.$apollo.queries.me.refetch()
        console.log('Me = ', value)
        this.footFallList = value.footfalls.data
        this.pagination = value.footfalls.paginatorInfo
        console.log('this.footFallList', this.footFallList)
        this.totalItems = this.pagination.total
        console.log('this.applicationList Length', this.totalItems)
      },
      '$apollo.loading': function (loading) {
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      }
    },
    methods: {
      clearSearch(){
        this.fromDate = '';
        this.toDate = '';
        this.footFallList = []
      },
      customFormatter(fromDate, toDate) {
        if(fromDate)
          return moment(fromDate).format('yyyy-MM-DD');
        else
          return moment(toDate).format('yyyy-MM-DD');
      },
      searchByDate(){

      },
      addNewFootfall () {
        this.$router.push('/new_footfall').catch(() => {
        })
      },
      hire () {
        this.$router.push('/hire_agreement').catch(() => {
        })
      },
      footFallDetal (id) {
        this.$router.push('/footfallDetails/' + id).catch(() => {
        })
      },
      updateFootFall (id) {
        this.$router.push('/updateFootfall/' + id).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      }

    },
    components: {
      Datepicker
    }
  }
</script>
